import DetailViewsZeroState from './DetailViewsZeroState';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Flex } from 'foundations-components/components/Flex';
import { H5 } from 'foundations-components/transitional/components/H5';
import { Link } from 'foundations-components/transitional/components/Link';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoadableDetailViewsCardContents = Loadable({
  loader: () => import( /* webpackChunkName: "presentation-detail-card" */'./DetailViewsCardContents'),
  LoadingComponent: ({
    pastDelay
  }) => pastDelay ? /*#__PURE__*/_jsx(LoadingSpinner, {
    layout: "centered"
  }) : null,
  ErrorComponent: ({
    retry
  }) => /*#__PURE__*/_jsx(Alert, {
    use: "inline",
    type: "danger",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "summary.detail.views.error.title"
    }),
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "summary.detail.views.error.description_jsx",
      options: {
        onClick: retry
      },
      elements: {
        Link
      }
    })
  })
});
const DetailViewsCard = ({
  revisits,
  allDocumentSlides,
  contact
}) => {
  if (!revisits) {
    return /*#__PURE__*/_jsx(Flex, {
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        grow: true,
        minHeight: 200,
        layout: "centered"
      })
    });
  }
  return /*#__PURE__*/_jsxs(View, {
    paddingInlineStart: "400",
    children: [/*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "summary.detail.views.title"
      })
    }), revisits.isEmpty() ? /*#__PURE__*/_jsx(DetailViewsZeroState, {
      contact: contact
    }) : /*#__PURE__*/_jsx(LoadableDetailViewsCardContents, {
      revisits: revisits,
      allDocumentSlides: allDocumentSlides
    })]
  });
};
export default DetailViewsCard;